import { faDoorOpen } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Button, CalloutBanner } from '@growtherapy/sprout-ui';

import { useCountdown } from '../../../hooks/useCountdown';

export function JoinSessionCallout({
  countdown,
  joinCallback,
}: {
  countdown?: string | null;
  joinCallback: () => void;
}) {
  const t = useTranslate();
  return (
    countdown && (
      <CalloutBanner
        use='green'
        icon={faDoorOpen}
        heading={t('telehealth-core:waitingRoom.yourProviderIsReadyToSeeYou')}
        headingVariant='md'
        actions={[
          <Button key='joinSession' use='secondary' onClick={joinCallback}>
            {t('telehealth-core:waitingRoom.joinSessionNow')}
          </Button>,
        ]}
        data-testid='deadline'
        className='z-20'
      >
        {t('telehealth-core:waitingRoom.automaticallyTransferringInSeconds', {
          countdown,
        })}
      </CalloutBanner>
    )
  );
}

/**
 * @deprecated
 */
export function JoinSessionCalloutWrapper({
  deadline,
  joinCallback,
}: {
  deadline?: Date | null;
  joinCallback: () => void;
}) {
  const countdown = useCountdown({
    deadline,
    formatString: 's',
    onFinish: joinCallback,
  });

  return <JoinSessionCallout countdown={countdown} joinCallback={joinCallback} />;
}
